import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconCheckboxCheck = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_3344_12826)">
        <path
          d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
          stroke={theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12L11 14L15 10"
          stroke={theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3344_12826">
          <rect width="24" height="24" fill={theme.colors.background.primary} />
        </clipPath>
      </defs>
    </IconBase>
  )
}
